var React = require('react');

function CeIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#005BA2","d":"M0 0h129v129H0z","key":0}),React.createElement("path",{"d":"M39 39h52.578v52.578H39z","key":1}),React.createElement("path",{"d":"M48.56 68.243v10.015l16.729 9.564 16.73-9.564V68.243l-16.73 9.564-16.73-9.564zm16.729-25.487L39 57.778 65.289 72.8l21.509-12.293v17.3h4.78v-20.03l-26.29-15.021z","fill":"#FFF","key":2})]));
}

CeIcon.displayName = "CeIcon";

CeIcon.defaultProps = {"width":"129","height":"129"};

module.exports = CeIcon;

CeIcon.default = CeIcon;
